module.exports = __webpack_public_path__ + "img/transfer_bg.e6446922.jpg";